var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"live_dianzan"},[_c('canvas',{staticStyle:{"width":"100px","height":"200px"},attrs:{"id":"thumsCanvas","width":"200","height":"400"}})])
}]

export { render, staticRenderFns }